import React from 'react';
import styled from 'styled-components';

type GisPolicyProps = {
  className?: string;
};

const Col = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const H1 = styled.h1`
  margin: 0 0 14px;
  font-size: 44px;
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: -0.02em;

  @media (max-width: 767px) {
    font-size: 34px;
  }
`;

const H2 = styled.h2`
  margin: 26px 0 10px;
  font-size: 26px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: -0.01em;

  @media (max-width: 767px) {
    font-size: 22px;
  }
`;

const P = styled.p`
  margin: 0 0 14px;
  font-size: 16px;
  line-height: 1.75;
  color: rgba(11, 18, 32, 0.86);
`;

const Ol = styled.ol`
  margin: 8px 0 18px 18px;
  padding: 0;
  font-size: 16px;

  li {
    margin: 0 0 12px;
    line-height: 1.75;
    color: rgba(11, 18, 32, 0.86);
  }
`;

const Buttons = styled.div`
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const ExternalButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 10px 14px;
  border-radius: 10px;

  background: #b1002a;
  color: #ffffff;
  text-decoration: none;
  font-weight: 800;
  letter-spacing: 0.02em;

  transition: transform 160ms ease, opacity 160ms ease;

  &:hover {
    transform: translateY(-1px);
    opacity: 0.92;
  }
`;

export const GisPolicy: React.FC<GisPolicyProps> = ({ className }) => (
        <Col className={className}>
            <H1>GIS Policy and Procedures Manual</H1>

            <P>
                This GIS Policy and Procedures Manual has been produced to advise and support AWMAC, AWMAC
                Chapters, AWMAC Members, Inspectors, Design Professionals and other interested parties
                involved in the program. It outlines standardized policies and procedures for the GIS
                program across Canada.
            </P>

            <H2>Tips for Reading and Understanding this Policy and Procedures Manual</H2>

            <Ol>
                <li>
                    The GIS participants are identified in Section 1 Owner and Design Professional, through
                    Section 6 Inspector. Each section states the relationship and responsibilities between
                    itself and the other connected firms, associations, committees, members and contractors
                    and are numbered in identical format. Each of these sections can be used as a stand-alone
                    document and states the procedures for that participant.
                </li>
                <li>
                    Section 7 Financial, through Section 9 Compliance states the policies and procedures for
                    these GIS components.
                </li>
            </Ol>

            <Buttons>
                <ExternalButton
                    href=""
                    rel="noopener noreferrer"
                >
                    GIS Policy and Procedures Manual 3.1 – English
                </ExternalButton>

                <ExternalButton
                    href=""
                    rel="noopener noreferrer"
                >
                    GIS Policy and Procedures Manual 3.1 – French
                </ExternalButton>
            </Buttons>
        </Col>
);
